module.exports = __webpack_public_path__ + "img/hemi.e33ed992.png";